"use client";
import StarBoldIcon from "@/app/_components/Icons/StarBoldIcon";

import CardCarousel from "./CardCarousel";
import { useGqlClient } from "@/Providers/GQLProvider";
import { useQuery } from "@tanstack/react-query";

type Props = {
  catId: number;
};
export default function BestSellingProductsSection({ catId }: Props) {
  const gqlClient = useGqlClient();

  const { data, isFetching, isLoading } = useQuery({
    queryKey: [gqlClient.HomePageData.name, catId],
    queryFn: () => {
      return gqlClient.HomePageData({ categoryId: catId });
    },
    select(data) {
      if (data) {
        return data.homePageData.mostSaleProducts;
      } else[];
    },
  });
  return (
    <>
      <CardCarousel
        items={data as any}
        loading={isFetching || isLoading}
        title={"پرفروش ترین  <b>محصولات</b>"}
        icon={<StarBoldIcon />}
        href="/products?sort=sale"
        showMore
        surface="home_most_sale"
      />
    </>
  );
}
